import { Component, Input, OnInit } from '@angular/core';
import { ProgressData } from '@core/interfaces/partners-ALI';

@Component({
  selector: 'app-allies-progress-skeleton',
  templateUrl: './allies-progress-skeleton.component.html',
  styleUrls: ['./allies-progress-skeleton.component.scss']
})
export class AlliesProgressSkeletonComponent implements OnInit {
@Input() currentYear;
@Input() mockProgressData!: ProgressData;
readonly cards = [
  { id: 1, name: 'Card 1' },
  { id: 2, name: 'Card 2' },
  { id: 3, name: 'Card 3' }
];
  constructor() { }

  ngOnInit() {
  }
// Obtener la medalla del próximo nivel
  getNextLevelMedal(): string {
    const current = this.mockProgressData.currentAmount;
    
    if (current < 250000) {
      return '/assets/image/partners-ali/medal-plata.svg';
    } else if (current < 300000) {
      return '/assets/image/partners-ali/medal-oro.svg';
    } else if (current < 350000) {
      return '/assets/image/partners-ali/medal-diamond.svg';
    } else {
      return '/assets/image/partners-ali/medal-diamond.svg'; // Ya eres Diamante
    }
  }
   getTotalPages() {
    return this.cards;
  }

}
